import * as crowdCreateCopy from '../services/crowdCreateCopy';
import { filterTreeTags } from '.././constants';

export default {
  namespace: 'crowdCreateCopy',

  state: {
    TagAndRuleDetail: null,
    ruleLabelDirectoryList: null,
    tagBehaviorConditionList: null,
    tagBehaviorConditionListDate: null,
    treeTags: [],
  },

  effects: {
    // 创建人群
    *insertOrUpdateGroupAndRule({ payload: { values }, callback }, { call }) {
      const response = yield call(
        crowdCreateCopy.insertOrUpdateGroupAndRule,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    // 非集合标签规则详情
    *queryTagAndRule({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdCreateCopy.queryGroupAndRule, values);
      yield put({
        type: 'save',
        payload: {
          groupAndRule: response?.data,
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
    // 人群级联数据
    *queryFileList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdCreateCopy.queryFileList, values);
      const treeList = response.data || [];
      yield put({
        type: 'save',
        payload: {
          ruleLabelDirectoryList: treeList,
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
    *getQueryTagOperatorValue(_, { call, put }) {
      const responseTag = yield call(
        crowdCreateCopy.getQueryTagOperatorValue,
        [],
      );
      yield put({
        type: 'save',
        payload: {
          queryTagOperatorValue: responseTag.data,
        },
      });
    },

    *getTreeTags({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdCreateCopy.getTreeTags, {
        ...values,
      });
      const treeTags = filterTreeTags(response?.data);
      yield put({
        type: 'save',
        payload: {
          treeTags: treeTags,
        },
      });
      response.code === 0 && callback && callback(treeTags);
    },
    *deleteLabel({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdCreateCopy.deleteLabel, values);
      callback(response);
    },
    *selectOption({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdCreateCopy.selectOption, {
        ...values,
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *predict({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdCreateCopy.predict, {
        ...values,
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname.includes('/profile/crowd_manage/crowd_edit') ||
          props.pathname.includes('/profile/crowd_manage/crowd_add')
        ) {
          dispatch({
            type: 'save',
            payload: {
              TagAndRuleDetail: null,
              ruleLabelDirectoryList: null,
              tagBehaviorConditionList: null,
              tagBehaviorConditionListDate: null,
              treeTags: [],
            },
          });
        }
      });
    },
  },
};
